/**
 * FAQ Block JavaScript
 * Handles accordion functionality for FAQ items
 */

export function initFAQ() {
    // FAQ Accordion
    const questions = document.querySelectorAll('.faq-question');
    
    if (questions.length === 0) return;
    
    questions.forEach(question => {
        question.addEventListener('click', function(e) {
            e.preventDefault();
            
            const answer = this.nextElementSibling;
            const icon = this.querySelector('.faq-icon');
            const isOpen = !answer.classList.contains('hidden');
            
            // Close all other answers
            const allAnswers = document.querySelectorAll('.faq-answer');
            const allIcons = document.querySelectorAll('.faq-icon');
            
            allAnswers.forEach(a => a.classList.add('hidden'));
            allIcons.forEach(i => i.classList.remove('rotate'));
            
            // Toggle current answer
            if (!isOpen) {
                answer.classList.remove('hidden');
                icon.classList.add('rotate');
            }
        });
    });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQ);
} else {
    initFAQ();
}

// Export for use in main.js if needed
export default initFAQ;